import cookieUtils from '@/intl-jdi-common-ssr/utils/cookieUtils';
import _ from 'lodash';
import { getJDISiteKeys } from '@/utils/multiSite';

type JsonObject = {
  [key: string]: string | number | JsonObject;
};

export const fallbackLng = {
  en_GB: ['en'],
  en_US: ['en'],
  zh_CN: ['zh'],
  zh_TW: ['en'],
  nl_NL: ['nl'],
  de_DE: ['de'],
  fr_FR: ['fr'],
  default: ['en'],
};

export const mergeObjects = (a: JsonObject, b: JsonObject) => {
  return _.merge(a, b);
};

export const getI18nLang = () => {
  let lang = cookieUtils.getCookie('_lang');
  if (!lang) {
    lang = getJDISiteKeys()['JDI-Default-Lang'];
  }
  return lang;
};

export const setI18nLang = (language: string) => {
  return cookieUtils.setCookie('_lang', language, 90);
};

/**
 * 浏览器语言映射
 */
const LANGUAGE_RULES = [
  // 简体中文
  {
    target: 'zh_CN',
    exact: ['zh', 'zh-CN', 'zh-Hans', 'zh-Hans-CN', 'zh-CHS', 'zh-SG', 'zh-MY'],
  },
  // 繁体中文
  {
    target: 'zh_TW',
    exact: [
      'zh-TW',
      'zh-HK',
      'zh-MO',
      'zh-Hant',
      'zh-Hant-TW',
      'zh-Hant-HK',
      'zh-Hant-MO',
      'zh-CHT',
    ],
  },
  // 德语
  {
    target: 'de_DE',
    exact: ['de'],
    startsWith: 'de-',
  },
  // 法语
  {
    target: 'fr_FR',
    exact: ['fr'],
    startsWith: 'fr-',
  },
  // 荷兰语
  {
    target: 'nl_NL',
    exact: ['nl'],
    startsWith: 'nl-',
  },
  // 英语
  {
    target: 'en_GB',
    exact: ['en'],
    startsWith: 'en-',
  },
];

/**
 * @param language
 * @returns
 */
const mapLanguageCode = (language: string): string => {
  if (!language) return '';

  for (const rule of LANGUAGE_RULES) {
    if (rule.exact.includes(language)) {
      return rule.target;
    }

    if (rule.startsWith && language.startsWith(rule.startsWith)) {
      return rule.target;
    }
  }

  return '';
};

/**
 * 获取浏览器语言（客户端）
 * @returns
 */
export const getBrowserLanguage = (): string => {
  const browserLanguage =
    typeof navigator !== 'undefined' ? navigator.language || navigator.languages?.[0] || '' : '';

  return mapLanguageCode(browserLanguage);
};

/**
 * 获取浏览器语言（服务端）
 * @param acceptLanguage Accept-Language 请求头
 * @returns
 */
export const getServerLanguage = (acceptLanguage: string): string => {
  if (!acceptLanguage) return '';

  const languages = acceptLanguage
    .split(',')
    .map((lang) => lang.split(';')[0].trim())
    .filter(Boolean);

  const mapped = mapLanguageCode(languages?.[0]);
  if (mapped) {
    return mapped;
  }

  return '';
};
